/**
 * CSS custom property names. Values are defined once in `styles/design-tokens.css`.
 * Change colors there (or swap the light/dark blocks) — components pick up updates automatically.
 */
export const JO_VAR = {
  primary: '--jo-primary',
  primaryHover: '--jo-primary-hover',
  accentSoft: '--jo-accent-soft',
  success: '--jo-success',
  warning: '--jo-warning',
  danger: '--jo-danger',
  text: '--jo-text',
  textMuted: '--jo-text-muted',
  textSubtle: '--jo-text-subtle',
  textDisabled: '--jo-text-disabled',
  border: '--jo-border',
  borderMuted: '--jo-border-muted',
  borderStrong: '--jo-border-strong',
  surface: '--jo-surface',
  surfaceMuted: '--jo-surface-muted',
  surfaceSubtle: '--jo-surface-subtle',
  surfaceHover: '--jo-surface-hover',
  bgStart: '--jo-bg-start',
  hoverBg: '--jo-hover-bg',
  chromeHover: '--jo-chrome-hover',
  divider: '--jo-divider',
  shadow: '--jo-shadow',
  shadowMd: '--jo-shadow-md',
  onPrimary: '--jo-on-primary',
  onSurface: '--jo-on-surface',
  dangerMuted: '--jo-danger-muted',
  starFilled: '--jo-star-filled',
  starEmpty: '--jo-star-empty',
  starHover: '--jo-star-hover',
  scrollbarThumb: '--jo-scrollbar-thumb',
  scrollbarThumbHover: '--jo-scrollbar-thumb-hover',
  highlightSearch: '--jo-highlight-search',
} as const;

/** Use in React `style` props and Ant Design color props (`twoToneColor`, etc.). */
export const jo = {
  primary: `var(${JO_VAR.primary})`,
  primaryHover: `var(${JO_VAR.primaryHover})`,
  accentSoft: `var(${JO_VAR.accentSoft})`,
  success: `var(${JO_VAR.success})`,
  warning: `var(${JO_VAR.warning})`,
  danger: `var(${JO_VAR.danger})`,
  text: `var(${JO_VAR.text})`,
  textMuted: `var(${JO_VAR.textMuted})`,
  textSubtle: `var(${JO_VAR.textSubtle})`,
  textDisabled: `var(${JO_VAR.textDisabled})`,
  border: `var(${JO_VAR.border})`,
  borderMuted: `var(${JO_VAR.borderMuted})`,
  borderStrong: `var(${JO_VAR.borderStrong})`,
  surface: `var(${JO_VAR.surface})`,
  surfaceMuted: `var(${JO_VAR.surfaceMuted})`,
  surfaceSubtle: `var(${JO_VAR.surfaceSubtle})`,
  surfaceHover: `var(${JO_VAR.surfaceHover})`,
  bgStart: `var(${JO_VAR.bgStart})`,
  hoverBg: `var(${JO_VAR.hoverBg})`,
  chromeHover: `var(${JO_VAR.chromeHover})`,
  divider: `var(${JO_VAR.divider})`,
  shadow: `var(${JO_VAR.shadow})`,
  shadowMd: `var(${JO_VAR.shadowMd})`,
  onPrimary: `var(${JO_VAR.onPrimary})`,
  onSurface: `var(${JO_VAR.onSurface})`,
  dangerMuted: `var(${JO_VAR.dangerMuted})`,
  starFilled: `var(${JO_VAR.starFilled})`,
  starEmpty: `var(${JO_VAR.starEmpty})`,
  starHover: `var(${JO_VAR.starHover})`,
  scrollbarThumb: `var(${JO_VAR.scrollbarThumb})`,
  scrollbarThumbHover: `var(${JO_VAR.scrollbarThumbHover})`,
  highlightSearch: `var(${JO_VAR.highlightSearch})`,
} as const;

/** Read a token value from the document root (e.g. meta theme-color). */
export const readCssVar = (name: keyof typeof JO_VAR, fallback = ''): string => {
  if (typeof document === 'undefined') {
    return fallback;
  }
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(JO_VAR[name])
    .trim();
  return value || fallback;
};
